import { render, staticRenderFns } from "./FinanceStudentViewAddEdit.vue?vue&type=template&id=6242043c"
import script from "./FinanceStudentViewAddEdit.vue?vue&type=script&lang=js"
export * from "./FinanceStudentViewAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports